var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4874 0.512563C12.804 -0.170854 11.696 -0.170854 11.0126 0.512563L10.2411 1.284L12.716 3.75888L13.4874 2.98744C14.1709 2.30402 14.1709 1.19598 13.4874 0.512563Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0089 4.46598L9.53403 1.99111L1.43347 10.0917C1.02228 10.5029 0.720021 11.01 0.554008 11.5673L0.0208212 13.3573C-0.0315921 13.5332 0.0166393 13.7237 0.146459 13.8535C0.276279 13.9834 0.466803 14.0316 0.642755 13.9792L2.43268 13.446C2.99 13.28 3.49716 12.9777 3.90836 12.5665L12.0089 4.46598Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNewIcon);
export default __webpack_public_path__ + "static/media/edit-new-icon.073c27a0a69345a5f797b34068592150.svg";
export { ForwardRef as ReactComponent };